var _classCallCheck = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var StorageStream = require('./ole-storage-stream');
var Storage = /*#__PURE__*/function () {
  "use strict";

  function Storage(doc, dirEntry) {
    _classCallCheck(this, Storage);
    this._doc = doc;
    this._dirEntry = dirEntry;
  }
  _createClass(Storage, [{
    key: "storage",
    value: function storage(storageName) {
      return new Storage(this._doc, this._dirEntry.storages[storageName]);
    }
  }, {
    key: "stream",
    value: function stream(streamName) {
      return new StorageStream(this._doc, this._dirEntry.streams[streamName]);
    }
  }]);
  return Storage;
}();
module.exports = Storage;